import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PageRoleList from './PageRole/PageRoleList'
import UserRoleList from './UserRole/UserRoleList'
import { useSelector } from 'react-redux'
import NotFound from '../../NotFound/NotFound'

const RoleTabbing = () => {
  const { userInfo } = useSelector((state) => state.user)
  const [activeToggle, setActiveToggle] = useState(
    userInfo?.userName === 'admin.k@hashtechy.com' ||
      userInfo?.userName === 'harsh@hashtechy.com'
      ? 'pageRole'
      : 'userRole'
  )

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return userInfo?.userType?.toLowerCase() === 'super admin' ? (
    <div className='card overflow-hidden'>
      <div className='card-body p-0'>
        <div className='nav-tabs-horizontal nav nav-tabs'>
          {userInfo?.userName === 'sweetupatel6933@gmail.com' && (
            <Link
              onClick={(e) => handleTabClick(e, 'pageRole')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'pageRole' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Page Role
                <hr />
              </span>
            </Link>
          )}
          <Link
            onClick={(e) => handleTabClick(e, 'userRole')}
            data-toggle='tab'
            className={`nav-link fw-semibold ${
              activeToggle === 'userRole' ? 'active show' : ''
            }`}
          >
            <span className='nav-span'>
              User Role
              <hr />
            </span>
          </Link>
        </div>
        <div className='tab-content p-3'>
          <div
            id='pageRole'
            className={`tab-pane fade ${
              activeToggle === 'pageRole' ? 'active show' : ''
            }`}
          >
            {activeToggle === 'pageRole' && <PageRoleList />}
          </div>
          <div
            id='userRole'
            className={`tab-pane fade ${
              activeToggle === 'userRole' ? 'active show' : ''
            }`}
          >
            {activeToggle === 'userRole' && <UserRoleList />}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <NotFound />
  )
}

export default RoleTabbing
